var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHarnais(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_14",
    "data-name": "Calque 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 615.52 1510.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#333335;}.cls-4{fill:#cbdca8;}.cls-5{fill:#728252;}.cls-6{fill:#c7c6bc;}.cls-7{fill:#686868;}.cls-8{fill:#1a191e;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-770.48 -212.59)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1366,1501c-11-32-16-73-13-99,16,3,16-11,6-21,0-11-15-28-31-53s-19-58-16-71,7-168,7-179a337.89,337.89,0,0,1,10-78c8.33-33.34,0-117-3-170s-9-151-10-171c9,0,10-8,10-8l-3-72s0-14-10-13c6-63-9-218-20-260s-37-63-50-62-60-6-66-6-41,45-46,49-7,13,3,14c-8,8-51,122-51,122s-33-70-42-84c7.14-1,15-12,15-12s-71-70-77-73-26,3-76,20c-22.36,7.6-37.12,68.2-46.61,132.88C852,412,851,422,853.25,429.87,844,502.5,841,573,841,573c-18.48,31.23-19.71,62.84,3,95,0,0,4,40,1,53-8,5-49-2-49-2-33,5-34,46-3,50l55-1s1,37,1,62-19,122-18,159,1,39,32,86c0,49,20,171,22,199-7,11-6,36-9,51s-17,24-17,24c-25.21.65-33.2,10.58-18,33-8.94,16.78-4.22,21.31,7,20,0,0,12,35,0,68s-36,137-13,204,95,53,134,23,31-99,31-99a334.49,334.49,0,0,0,23,46c66,82,95,48,120,36s54-54,54-54-5,19,6,47,80,89,136,15S1377,1533,1366,1501ZM798.5,764A19.5,19.5,0,1,1,818,744.5,19.5,19.5,0,0,1,798.5,764ZM1220,321c6,42,6,72,6,72-3,7.67-5,15.95,0,29l5,155c-17,1-18,93,7,93v48h-23s-30-100-51-123c15-21,20-25,12-34s-45-56-45-56S1206,337,1220,321ZM1051,640h64l29,88s-53-3-62,0-17,13-17,13h-9s2-11-4-13-21,0-21,0l-2,5-10-1v-4ZM926,671c16,1,22-85,0-91V434c4.75-.59,10.32-16.88,5-28-5.2-10.86,12-70,12-70s78,133,96,168c-39,41-53,55-39,78-17,33-51,146-51,146H926Zm4,1021c-20,0-38-7-54-92-6-51,15-137,12-171s5-23,5-23,6,44,26,101S958,1662,930,1692Zm236-150c-2,45-18,147-61,144s-53-38-58-128c0,0-68-189-112-245,5-93-6-106-21-124s-19-43-6-66-6-43-8-53,3-60,8-70c0,0,53-105,56-125,55-22,40-49,24-65l15-30s17,5,21,0,0-5,0-5l133-9,28,69c-6.61,22.33-1.86,39,18,48l67,139s-6,45,0,64,22,54,18,86c-12,30-3,27-7,49s-23,71-23,90S1168,1497,1166,1542Zm153,40c-15,70-44,86-64,96-2-5,2-77,24-138s16-187,16-187S1334,1512,1319,1582Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "harnais") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1366,1501c-11-32-16-73-13-99,16,3,16-11,6-21,0-11-15-28-31-53s-19-58-16-71,7-168,7-179a337.89,337.89,0,0,1,10-78c8.33-33.34,0-117-3-170s-9-151-10-171c9,0,10-8,10-8l-3-72s0-14-10-13c6-63-9-218-20-260s-37-63-50-62-60-6-66-6-41,45-46,49-7,13,3,14c-8,8-51,122-51,122s-33-70-42-84c7.14-1,15-12,15-12s-71-70-77-73-26,3-76,20c-22.36,7.6-37.12,68.2-46.61,132.88C852,412,851,422,853.25,429.87,844,502.5,841,573,841,573c-18.48,31.23-19.71,62.84,3,95,0,0,4,40,1,53-8,5-49-2-49-2-33,5-34,46-3,50l55-1s1,37,1,62-19,122-18,159,1,39,32,86c0,49,20,171,22,199-7,11-6,36-9,51s-17,24-17,24c-25.21.65-33.2,10.58-18,33-8.94,16.78-4.22,21.31,7,20,0,0,12,35,0,68s-36,137-13,204,95,53,134,23,31-99,31-99a334.49,334.49,0,0,0,23,46c66,82,95,48,120,36s54-54,54-54-5,19,6,47,80,89,136,15S1377,1533,1366,1501ZM798.5,764A19.5,19.5,0,1,1,818,744.5,19.5,19.5,0,0,1,798.5,764ZM1220,321c6,42,6,72,6,72-3,7.67-5,15.95,0,29l5,155c-17,1-18,93,7,93v48h-23s-30-100-51-123c15-21,20-25,12-34s-45-56-45-56S1206,337,1220,321ZM1051,640h64l29,88s-53-3-62,0-17,13-17,13h-9s2-11-4-13-21,0-21,0l-2,5-10-1v-4ZM926,671c16,1,22-85,0-91V434c4.75-.59,10.32-16.88,5-28-5.2-10.86,12-70,12-70s78,133,96,168c-39,41-53,55-39,78-17,33-51,146-51,146H926Zm4,1021c-20,0-38-7-54-92-6-51,15-137,12-171s5-23,5-23,6,44,26,101S958,1662,930,1692Zm236-150c-2,45-18,147-61,144s-53-38-58-128c0,0-68-189-112-245,5-93-6-106-21-124s-19-43-6-66-6-43-8-53,3-60,8-70c0,0,53-105,56-125,55-22,40-49,24-65l15-30s17,5,21,0,0-5,0-5l133-9,28,69c-6.61,22.33-1.86,39,18,48l67,139s-6,45,0,64,22,54,18,86c-12,30-3,27-7,49s-23,71-23,90S1168,1497,1166,1542Zm153,40c-15,70-44,86-64,96-2-5,2-77,24-138s16-187,16-187S1334,1512,1319,1582Z",
    transform: "translate(-770.48 -212.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M854,644h21s-2-317.47,51-377.73c-6-10.27-12.63,4.22-12.63,4.22S859,316,854,644Z",
    transform: "translate(-770.48 -212.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M890,644h21s-12-331.47,41-391.73c-6-10.27-12.63,4.22-12.63,4.22S890,296,890,644Z",
    transform: "translate(-770.48 -212.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1304,575h-21s10-269-64-358.73c6-10.27,12.63,4.22,12.63,4.22S1304,285,1304,575Z",
    transform: "translate(-770.48 -212.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1268,575h-21s6-290.47-47-350.73c6-10.27,12.63,4.22,12.63,4.22S1261,249,1268,575Z",
    transform: "translate(-770.48 -212.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1084,537s112-252,126-265c4,11,4,16,4,16s-74,144-115,249Z",
    transform: "translate(-770.48 -212.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1069,537s86-228,135-271c-9-11-3-6-8-8-61,58-114,226-138,279Z",
    transform: "translate(-770.48 -212.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1238,670V612c10-1,74-7,74-7l4,54,16,11-10-116-9,12-1,9h-85l-13,4-10,33,22,58Z",
    transform: "translate(-770.48 -212.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M844,674V616c10-1,82,1,82,1v54l12,3,6-45.44V559l-17,6-1,16-85.94-2,.94-12-21,16-10,33,22,58Z",
    transform: "translate(-770.48 -212.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M950,310a118.94,118.94,0,0,1,4-14c8,3,97,157,107,179-5,17-5,14-5,14S966,332,950,310Z",
    transform: "translate(-770.48 -212.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M959,285l8-10s51.24,75.28,63,97c13,24,44,74,44,74l-4,13S975,295,959,285Z",
    transform: "translate(-770.48 -212.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1132,502.78,1115,537h-75l16-40-3-2c-3-2-14,9-14,9l-44,6-17,10-5,39,27,23s28,36,39,49,14,9,14,9l38,2s24-1,29-2,44-45,44-45l20-29ZM1053,624l-45-49,19-25,45,51Zm61,3-20-19,50-49a209.53,209.53,0,0,1,21,20C1155,594,1114,627,1114,627Z",
    transform: "translate(-770.48 -212.59)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "265 347.01 246.02 371.67 255.51 382 275.79 359.25 265 347.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "263.41 390.6 283.57 368.07 291.94 377.54 272.75 400.77 263.41 390.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "334.74 384.42 350.39 409.26 363.06 398.34 344.95 374.41 334.74 384.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "355.06 364.51 373.52 388.62 383.09 379.49 362.67 357.04 355.06 364.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "237.52 382.41 188.52 515.41 202.52 515.41 248.52 393.63 237.52 382.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "258.58 406.26 215.52 518.41 229.52 518.41 268.52 418.41 258.58 406.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "194.52 584.41 200.52 565.41 211.52 565.41 203.52 586.41 194.52 584.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "185.52 581.41 193.52 561.41 181.52 561.41 177.52 580.41 185.52 581.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M961,812l-12,41s3,2,8,1c4-13,14-42,14-42Z",
    transform: "translate(-770.48 -212.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M940,875s1,2,8,2c-2,14-28,85-39,98V961S937,895,940,875Z",
    transform: "translate(-770.48 -212.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M932,875s-15,50-23,67V932s16-55,17-60C930,875,932,875,932,875Z",
    transform: "translate(-770.48 -212.59)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "359.02 419.45 368.52 409.41 402.52 509.41 388.52 509.41 359.02 419.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "376.89 400.77 385.06 391.83 429.52 509.41 417.52 509.41 376.89 400.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "402.52 551.41 418.52 551.41 437.52 605.41 423.52 612.41 402.52 551.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1201,839s3-6,13-3c7,14,14,34,14,34s-7,2-12,0C1212,862,1201,839,1201,839Z",
    transform: "translate(-770.48 -212.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1219,882h12c7,21,25,67,37,85v16S1234,927,1219,882Z",
    transform: "translate(-770.48 -212.59)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "467.52 669.41 481.52 669.41 490.52 699.41 493.52 724.41 467.52 669.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1234,867s8,3,12-4a256.42,256.42,0,0,1-12-26h-11Z",
    transform: "translate(-770.48 -212.59)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "443.52 599.41 429.52 548.41 440.52 548.41 454.52 599.41 443.52 599.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1255,1678s-41.43,14.58-54.71-12.71S1200,1621,1200,1621s22-64,38-92,57.59-155.84,57-176,9,110,9,110Z",
    transform: "translate(-770.48 -212.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M930,1692s40,8,49-12,19-41,17-65-7-58-18-73-71-137-73-152-5-37-5-37-10,49-9,60S930,1692,930,1692Z",
    transform: "translate(-770.48 -212.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M859.14,1377.38S842,1361,851,1359s21.65,3.66,21.65,3.66S865.28,1376.76,859.14,1377.38Z",
    transform: "translate(-770.48 -212.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M841,1382s-2,4,5,3,25-16,29-27c0,0,5-11,12-9s-4,29-8,36-31,17-31,17l-19,5v-16Z",
    transform: "translate(-770.48 -212.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1295,1353s23,41,45,48,46-8,46-8l-27-12s-4,11-18,3-43-55-43-55S1289,1336,1295,1353Z",
    transform: "translate(-770.48 -212.59)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarnais);
export default __webpack_public_path__ + "static/media/harnais.bf73be169763335a71aee8b4f31955fd.svg";
export { ForwardRef as ReactComponent };